// CUSTOM: personalised-cart-totals.js
// Updates total savings calculation for personalised bundle items

(function() {
  'use strict';
  
  // Run on DOMContentLoaded to ensure sessionStorage and DOM are available
  document.addEventListener('DOMContentLoaded', updateCompareAtPrices);
  
  // Add listener for cart updates via AJAX
  document.addEventListener('cart:updated', function() {
    updateCompareAtPrices();
  });
  
  // Add listener for cart updates via AJAX
  document.addEventListener('cart:updated', function() {
    updateCompareAtPrices();
  });
  
  function updateCompareAtPrices() {
    if (!window.personalised || !window.personalised.cartUtils) {
      return;
    }
    
    // Step 1: Calculate the total price for personalised items from sessionStorage
    let personalisedTotal = 0;
    
    try {
      // Get all personalised variants and their quantities
      const personalisedItems = document.querySelectorAll('.js-personalised-compare-total');
      
      personalisedItems.forEach(function(element) {
        const variantId = element.getAttribute('data-variant-id');
        const quantity = parseInt(element.getAttribute('data-quantity'), 10) || 1;
        
        // Get price data from our lookup utility
        const priceData = window.personalised.cartUtils.getVariantPrices(variantId);
        
        if (priceData && priceData.compare_at_price) {
          const totalPrice = priceData.compare_at_price * quantity;
          personalisedTotal += totalPrice;
        }
      });
      
      // Step 2: Get the non-personalised total
      const grandTotalElement = document.querySelector('.js-personalised-compare-at-total');
      if (grandTotalElement) {
        // Get the fallback value (non-personalised items total)
        const fallbackValue = parseInt(grandTotalElement.getAttribute('data-fallback-value')) || 0;
        
        // Calculate new total
        const newTotal = fallbackValue + personalisedTotal;
        
        // Format and update
        const formattedTotal = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(newTotal/100);
        grandTotalElement.textContent = formattedTotal;
        
        // Update discount percentage badges
        try {
          // Find all compare-at price elements
          const compareAtElements = document.querySelectorAll('.compare-at-price');
          
          compareAtElements.forEach(function(element) {
            const compareAtTotal = element.querySelector('.js-personalised-compare-at-total');
            if (!compareAtTotal) return;
            
            // Get the compare-at price from the data attribute
            const compareAt = parseInt(compareAtTotal.getAttribute('data-fallback-value'), 10) + personalisedTotal;
            if (!compareAt) return;
            
            // Get the current subtotal from the parent element's visible price text
            const subtotalElement = element.closest('.totals__subtotal-value');
            if (!subtotalElement) return;
            
            // Get the last text node which should be the current price
            const priceText = Array.from(subtotalElement.childNodes)
              .filter(node => node.nodeType === 3) // Text nodes only
              .pop();
            
            if (!priceText) return;
            
            // Parse the visible price text, removing all non-numeric characters except decimal point
            const subtotal = (parseFloat(priceText.textContent.replace(/[^\d.]/g, '')) * 100) || 0;
            if (!subtotal || isNaN(subtotal)) return;
            
            // Calculate percentage discount with division-by-zero guard
            const percent = compareAt > 0 ? Math.round((compareAt - subtotal) / compareAt * 100) : 0;
            
            // Update or hide the badge
            const badge = element.querySelector('.compare-at-badge');
            
            // # compare-at fix: use data-ready attribute for visibility
            if (badge) {
              if (percent > 0) {
                // Reset and set new text in one operation
                badge.textContent = `${percent}% off`;
                badge.style.display = '';
                // Set data-ready to control visibility via CSS
                element.setAttribute('data-ready', 'true');
              } else {
                badge.style.display = 'none';
                // Hide via data attribute
                element.setAttribute('data-ready', 'false');
              }
            }
          });
        } catch (e) {
          console.error('Error updating discount percentages:', e);
        }
      }
      
    } catch (e) {
      console.error('Error updating compare-at prices:', e);
    }
  }
  
  // Retry mechanism for when productData isn't ready yet
  let retryAttempts = 0;
  function scheduleUpdateRetry() {
    // Only retry a few times with increasing delay
    if (retryAttempts >= 3) return;
    
    const delay = 200 * Math.pow(2, retryAttempts); // 200ms, 400ms, 800ms
    retryAttempts++;
    
    setTimeout(() => {
      // Check if we have any personalised items but no prices
      const personalisedItems = document.querySelectorAll('.js-personalised-compare-total');
      if (personalisedItems.length > 0) {
        // Only retry if we don't have product data or sessionStorage isn't populated
        const needsRetry = !window.personalised?.productData || 
                          !sessionStorage.getItem('personalised_variant_prices');
        if (needsRetry) {
          console.debug('[personalised] Retrying compare-at update, attempt:', retryAttempts);
          updateCompareAtPrices();
          scheduleUpdateRetry(); // Schedule another retry if needed
        }
      }
    }, delay);
  }
  
  // Initial retry schedule
  if (document.querySelectorAll('.js-personalised-compare-total').length > 0) {
    scheduleUpdateRetry();
  }
})();
